import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
    driveData: null,
    loading: false,
    error: null,
    confirmLoading: false,
    confirmSuccess: false,
    driveOccurrence: null,
    lobbyHeartbeatData: null,
    lobbyDriveScheduleData: null,
    notifyDriveScheduleLoading: false,
};
export const driveSlice = createSlice({
    name: 'driveDetails',
    initialState,
    reducers: {
        fetchDriveDetails: (state, _action) => {
            state.loading = true;
        },
        driveDetailsSuccess: (state, action) => {
            state.loading = false;
            state.driveData = action.payload;
        },
        confirmDriveSlotRequest: (state, _action) => {
            state.confirmLoading = true;
        },
        confirmDriveSlotSuccess: (state) => {
            state.confirmLoading = false;
            state.confirmSuccess = true;
        },
        confirmDriveSlotFailure: (state, action) => {
            state.confirmLoading = false;
            state.confirmError = action.payload;
        },
        fetchDriveOccurrenceDetails: (state, _action) => {
            state.loading = true;
        },
        driveOccurrenceDetailsSuccess: (state, action) => {
            state.loading = false;
            state.driveOccurrence = action.payload;
            state.error = null;
        },
        cancelDriveOccurrenceGuestRequest: (state, _action) => {
            state.loading = true;
        },
        cancelDriveOccurrenceGuestSuccess: (state, _action) => {
            state.loading = false;
        },
        registerCandidateToDriveRequest: (_state, _action) => {
            // state.loading = true;
        },
        registerCandidateToDriveSuccess: (_state, _action) => {
            // state.loading = false;
        },
        subscribeLobbyDriveScheduleRequest: (state, _action) => {
            state.loading = true;
        },
        subscribeLobbyDriveScheduleDetailsSuccess: (state, action) => {
            state.loading = false;
            state.lobbyDriveScheduleData = action.payload;
        },
        unsubscribeLobbyDriveSchedule: (state) => {
            state.loading = false;
            state.lobbyDriveScheduleData = null; // Set back to null when unsubscribed
        },
        subscribeDriveOccurrenceGuestTimesRequest: (_state, _action) => {
            // subscription handled via saga
        },
        updateDriveOccurrenceGuestTimes: (state, action) => {
            if (state.driveData) {
                state.driveData.from = action.payload.from;
                state.driveData.to = action.payload.to;
                state.driveData.status = action.payload.status;
            }
        },
        updateDriveMemberStatusRequest: (state, _action) => {
            state.loading = true;
        },
        updateDriveMemberStatusSuccess: (state, _action) => {
            state.loading = false;
        },
        heartBeatStatusRequest: (state, _action) => {
            state.loading = true;
        },
        hearBeatStatusSuccess: (state, action) => {
            state.loading = false;
            state.lobbyHeartbeatData = action.payload;
        },
        stopLobbyDriveHeartBeat: (state) => {
            state.loading = false;
        },
        notifyDriveScheduleRequest: (state, _action) => {
            state.notifyDriveScheduleLoading = true;
        },
        notifyDriveScheduleSuccess: (state) => {
            state.notifyDriveScheduleLoading = false;
        },
    },
});
export const { fetchDriveDetails, driveDetailsSuccess, confirmDriveSlotRequest, confirmDriveSlotSuccess, confirmDriveSlotFailure, fetchDriveOccurrenceDetails, driveOccurrenceDetailsSuccess, cancelDriveOccurrenceGuestRequest, cancelDriveOccurrenceGuestSuccess, registerCandidateToDriveRequest, registerCandidateToDriveSuccess, subscribeLobbyDriveScheduleRequest, subscribeLobbyDriveScheduleDetailsSuccess, unsubscribeLobbyDriveSchedule, updateDriveMemberStatusRequest, updateDriveMemberStatusSuccess, heartBeatStatusRequest, hearBeatStatusSuccess, stopLobbyDriveHeartBeat, notifyDriveScheduleRequest, notifyDriveScheduleSuccess, subscribeDriveOccurrenceGuestTimesRequest, updateDriveOccurrenceGuestTimes, } = driveSlice.actions;
export default driveSlice.reducer;
